import actions from "./actions";
import types from "./constants";
import SRS from "../../../../services/StudentRecordService";
import get from "lodash.get";
import {getErssStatus} from "../../../../services/erssService";

const fetchSkillsDiagnosticReport = (student) => async (dispatch, getState) => {
  let studentId = null;
  const state = getState();
  const selectedLocale = get(state, 'reports.teacher.selectedLocale');
  const selectedCurriculum = get(state, 'reports.teacher.selectedCurriculum');
  const selectedCurriculumId = get(state, 'reports.teacher.selectedCurriculum.value');
  if (student) studentId = student.value;
  dispatch(actions[types.SKILLSDIAGNOSTIC_PENDING]());

  try {
    const { diagnosticData, displayErssStatus } = await fetchDiagnosticData(studentId,selectedLocale, selectedCurriculumId);
    let data = diagnosticData;
    console.log("skills diagnostic data", data);
    const domains = data.diagnostic.records;

    // Pass this flag to the Skills Diagnostic Component
    // TODO: Add an action creatore and just dispatch an action to show this (CLEANER WAY TO DO THIS)
    if(Array.isArray(domains) && domains[0]) {
      domains[0].displayErssStatus = displayErssStatus;
    }

    for (const domain of domains) {
      for (const [pindex, skillArea] of domain.progression.entries()) {
        const { grade, period } = skillArea.subSkills[0].skillAREAScore || {};
        skillArea.gradeLabel = `${grade}-${period}`;
        for (const [i, subSkill] of skillArea.subSkills.entries()) {
          const { grade, period } = subSkill.skillAREAScore || {};
          subSkill.gradeLabel = `${grade}-${period}`;
          if (subSkill.gradeLabel !== skillArea.gradeLabel) {
            let diffPeriodSubskills = skillArea.subSkills.splice(i);
            let addSkillArea = { ...skillArea };
            addSkillArea.gradeLabel = skillArea.gradeLabel;
            addSkillArea.subSkills = diffPeriodSubskills;
            domain.progression.splice(pindex + 1, 0, addSkillArea);
          }
        }
        skillArea.width = Math.max(20 * skillArea.subSkills.length, 150);
      }
    }
    dispatch(actions[types.SKILLSDIAGNOSTIC_COMPLETE](domains));
  } catch (e) {
    console.log("ERROR:", e);
    dispatch(actions[types.SKILLSDIAGNOSTIC_ERROR](e.message));
  }
};

async function fetchDiagnosticData(studentId,selectedLocale, selectedCurriculumId){
  const diagnosticData = await Promise.all([
      SRS.getSkillsDiagnosticData(studentId, selectedLocale, selectedCurriculumId),
      getErssStatus(studentId)]);

  let reportData = diagnosticData[0];
  return mapERSS(reportData,diagnosticData[1]);
}

function mapERSS(reportData,erssData){
  let diagnosticData = reportData;
  let displayErssStatus = false;

  erssData.forEach((domainRecord)=>{
    //Find the working domain in the diagnostic report records
    let workingDomain = diagnosticData.diagnostic.records.find(d=>d.domain === domainRecord.domain);
    if(workingDomain){
      //Now walk all the skills in the domain returned from the ERSS service
      domainRecord.progression.map((erssSkill)=>{
        let makeAllSkillsCurrent = false;
        //Find the skill to update in the diagnostic report record
        let skillToUpdate = workingDomain.progression.find(s=>s.skillId===erssSkill.skillId);
        if(skillToUpdate){
          let currentSkillCount = 0;
          //Now walk the individual subskills in the ERSS data
          erssSkill.subSkills.map((subSkill)=>{
            //Find and update the matching subskill in the diagnostic report data
            let subSkillToUpdate = skillToUpdate.subSkills.find(ss=>ss.skillId === subSkill.skillId)
            if(subSkillToUpdate){
              //NOTE: this will directly mutate diagnosticData - this is why there is no return from the map;
              subSkillToUpdate.taken = subSkill.taken;
              subSkillToUpdate.current = subSkill.current;
              if(subSkill.current) {
                // Take advantage of this loop to figure out whether we should show Erss Status or not
                // If there's at least 1 subSkill with current=true then we display the ERSS Status UI.
                displayErssStatus = true;
                makeAllSkillsCurrent = true;
                ++currentSkillCount;
              }
            }
          })
          skillToUpdate.currentSkillCount = currentSkillCount;
          //If we're displaying the status, light up the whole skill
          if(false && makeAllSkillsCurrent){
            skillToUpdate.current = true;
            skillToUpdate.subSkills.forEach((subSkill)=>{
              subSkill.current = true;
            });
          }
        }
      })
    }
  })

  return {
    diagnosticData,
    displayErssStatus,
  };
}

export default {
  fetchSkillsDiagnosticReport,
};
